import { Amplify } from "aws-amplify";
import { parseAmplifyConfig } from "aws-amplify/utils";

import outputs from "../../amplify_outputs.json";
import { getAccessToken } from "../components/common/auth/useAuth";

export const configureAmplify = () => {
  const parsedAmplifyConfig = parseAmplifyConfig({
    ...(outputs || {})
  });

  Amplify.configure(
    {
      ...parsedAmplifyConfig,
      API: {
        ...parsedAmplifyConfig.API,
        REST: outputs.custom.API
      }
    },
    {
      API: {
        REST: {
          retryStrategy: {
            strategy: "no-retry"
          },
          headers: async () => {
            const accessToken = await getAccessToken();

            return {
              ...(accessToken && { Authorization: accessToken })
            };
          }
        }
      }
    }
  );
};
